import { IInitialState } from "./types";

export const initialState: IInitialState = {
	collapseTutorialCategory: false,
	displayLimitedDealsDot: false,
	scrollToSection: undefined,
	isLPAnimationPlaying: false,
	seeFullTutorialAgain: false,
	tutorialSlideNumber: 0,
	deeplinkState: {
		isError: false,
		isSuccess: false,
		error: undefined,
		data: undefined
	}
};
